import { render, staticRenderFns } from "./transaction-growth-container.vue?vue&type=template&id=342fdc52&"
import script from "./transaction-growth-container.vue?vue&type=script&lang=js&"
export * from "./transaction-growth-container.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports